import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import { settingsAPI } from '../../services/api';

const WhatsAppButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check GDPR consent and show after 8 seconds
    const consent = localStorage.getItem('gdpr_consent');
    if (consent === 'accepted') {
      const timer = setTimeout(() => {
        setVisible(true);
      }, 8000);
      return () => clearTimeout(timer);
    }
  }, []);

  // Listen for GDPR acceptance
  useEffect(() => {
    const handleGDPRAccept = () => {
      setTimeout(() => setVisible(true), 8000);
    };
    window.addEventListener('gdpr-accepted', handleGDPRAccept);
    return () => window.removeEventListener('gdpr-accepted', handleGDPRAccept);
  }, []);

  const handleClick = async () => {
    const message = 'Hello, I want to know more about your services';
    
    // Track click
    try {
      await settingsAPI.trackWhatsAppClick('/', message);
    } catch (error) {
      console.error('Failed to track click:', error);
    }
    
    // Open WhatsApp
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/919824286872?text=${encodedMessage}`, '_blank');
  };

  if (!visible) return null;

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 z-40 animate-bounce-slow"
      data-testid="whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white" fill="white" />
    </button>
  );
};

export default WhatsAppButton;
